import { render, staticRenderFns } from "./VisionRecognitionConfig.vue?vue&type=template&id=18dae958&scoped=true"
import script from "./VisionRecognitionConfig.vue?vue&type=script&lang=ts"
export * from "./VisionRecognitionConfig.vue?vue&type=script&lang=ts"
import style0 from "./VisionRecognitionConfig.vue?vue&type=style&index=0&id=18dae958&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dae958",
  null
  
)

export default component.exports